import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { RowSelection$1, Table, Row, Cell, Column, FilterType } from "./Table.fs.js";
import { map, head, tail, length, isEmpty, empty, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { adminContent, ByCell, dateTimeCell } from "./Prelude.fs.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { append, empty as empty_1, singleton, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { count, many } from "../Api/ActionTypes.fs.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Create, Update } from "../Modals/ActionType.fs.js";
import { DomainEntity } from "../ClientTypes.fs.js";
import { Components_UnDelete, Components_Delete } from "../Modals/Modal.fs.js";

function nameParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["name"]);
    }
    else {
        return new FSharpResult$2(0, [["name", name]]);
    }
}

function detailParam(detail) {
    if (isNullOrWhiteSpace(detail)) {
        return new FSharpResult$2(1, ["detail"]);
    }
    else {
        return new FSharpResult$2(0, [["detail", detail]]);
    }
}

const columns = ofArray([new Column("name", "Name", new FilterType(0, [nameParam])), new Column("detail", "Detail", new FilterType(0, [detailParam])), new Column("lastModifiedOn", "Last Modified", undefined), new Column("lastModifiedBy", "Last Modified By", undefined)]);

function rowRender(projectId, actionType) {
    return new Row(actionType.Id, ofArray([new Cell("name", actionType.Name), new Cell("detail", actionType.Detail), new Cell("lastModifiedOn", dateTimeCell(actionType.LastModified)), new Cell("lastModifiedBy", createElement(ByCell, {
        projectId: projectId,
        by: actionType.LastModifiedBy,
    }))]));
}

export function ActionTypes(actionTypesInputProps) {
    let actions, actionTypes, actionTypes_1;
    const projectId = actionTypesInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState(empty());
    const selectedActionTypes = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const showDeleted = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const patternInput_4 = reactApi.useState(empty());
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_3[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "ActionTypes",
        columns: columns,
        initialFilters: toList(delay(() => (showDeleted ? singleton(["deleted", ""]) : empty_1()))),
        onFiltersChange: patternInput_4[1],
        fetchData: (actionTypeParams) => many(projectId, empty(), actionTypeParams),
        fetchCount: (actionTypeParams_1) => count(projectId, actionTypeParams_1),
        rowRender: (actionType) => rowRender(projectId, actionType),
        refresh: patternInput_3[0],
        rowSelection: new RowSelection$1(2, [patternInput_1[1]]),
    });
    const isNotEmpty = !isEmpty(selectedActionTypes);
    const isMoreThan1 = length(selectedActionTypes) !== 1;
    return adminContent(toList(delay(() => append(singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", showDeleted ? "Hide Deleted" : "Show Deleted"], ["onClick", (_arg) => {
        patternInput_2[1](!showDeleted);
    }]]))))), delay(() => append(singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Create"], ["onClick", (_arg_1) => {
        setAction("create");
    }], ["disabled", isNotEmpty ? true : showDeleted]]))))), delay(() => append(singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Update"], ["onClick", (_arg_2) => {
        setAction("update");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => (showDeleted ? singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "UnDelete"], ["onClick", (_arg_3) => {
        setAction("unDelete");
    }], ["disabled", isEmpty(selectedActionTypes)]]))))) : singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Delete"], ["onClick", (_arg_4) => {
        setAction("delete");
    }], ["disabled", isEmpty(selectedActionTypes)]])))))))))))))), table, (action != null) ? ((actions = action, (actions === "update") ? (!isEmpty(selectedActionTypes) ? (isEmpty(tail(selectedActionTypes)) ? createElement(Update, {
        projectId: projectId,
        actionType: head(selectedActionTypes),
        close: close,
    }) : undefined) : undefined) : ((actions === "delete") ? ((actionTypes = map((Item) => (new DomainEntity(10, [Item])), selectedActionTypes), createElement(Components_Delete, {
        projectId: projectId,
        entities: actionTypes,
        close: close,
    }))) : ((actions === "unDelete") ? ((actionTypes_1 = map((Item_1) => (new DomainEntity(10, [Item_1])), selectedActionTypes), createElement(Components_UnDelete, {
        projectId: projectId,
        entities: actionTypes_1,
        close: close,
    }))) : createElement(Create, {
        projectId: projectId,
        close: close,
    }))))) : undefined);
}

